import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArKM: CultureInfo = {
  name: 'ar-KM',
  displayName: 'العربية (جزر القمر)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-KM',
  parent: CultureInfoAr
};
